/*
 * @Descripttion: 获取微信登录code
 * @FilePath: /mall-wap-vue/src/utils/wechat.js
 * @Author: 张兴业
 * @Date: 2020-09-27 11:01:27
 * @LastEditors: hl
 * @LastEditTime: 2026-06-23 16:52:41
 */
import { v1 as uuidv1 } from "uuid";
import { $G, getAppId } from "@/global";
const guid = uuidv1();
const response_type = "code&scope=snsapi_userinfo";

function wechat() {
  const appid = getAppId();
  const origin = $G("https://wap.myazstore.com");
  const { href } = window.location;
  const redirect_uri = encodeURIComponent(`${href}#${guid}`); // 是否需要传递guid  暂时未想好
  const url = `${origin}/wechatauth.html?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${response_type}&state=${guid}`;
  window.location.replace(url);
}

export default wechat;
